<svg width="184px" height="172px" viewBox="0 0 184 172">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-228.000000, -265.000000)">
        <g transform="translate(228.000000, 265.000000)">
            <g transform="translate(29.776260, 35.081329)">
                <circle id="circle" fill="#50BBA0" cx="56.2931844" cy="56.2931844" r="56.2931844"></circle>
                <path
                    id="check"
                    d="M71.7793567,36.1505917 L46.1675969,61.7605406 L35.9250661,51.5180098 C33.0964181,48.6893618 28.5111833,48.6893618 25.6807243,51.5180098 C22.8520763,54.3466578 22.8520763,58.9337035 25.6807243,61.7641624 L41.0445206,77.1225259 C43.8731686,79.9511739 48.4620252,79.9511739 51.2888623,77.1225259 L82.0218875,46.3913116 C84.8505355,43.5626636 84.8541573,38.9774288 82.0236984,36.1469699 C79.1968613,33.3237546 74.6080047,33.3237546 71.7793567,36.1505917 Z"
                    fill="#FFFFFF"
                ></path>
            </g>
            <g id="stars">
                <path
                    d="M37.4491429,41.3339867 C40.9726955,41.3339867 43.8290993,30.5963905 43.8290993,27.0728378 C43.8290993,23.5492852 40.9726955,20.6928814 37.4491429,20.6928814 C33.9255902,20.6928814 31.0691864,23.5492852 31.0691864,27.0728378 C31.0691864,30.5963905 33.9255902,41.3339867 37.4491429,41.3339867 Z"
                    id="Oval-4"
                    fill="#FFB300"
                    opacity="0.2"
                    transform="translate(37.449143, 31.013434) rotate(-45.000000) translate(-37.449143, -31.013434) "
                ></path>
                <path
                    d="M137.73724,43.017315 C141.43593,43.017315 144.434311,31.7460097 144.434311,28.0473199 C144.434311,24.3486301 141.43593,21.3502496 137.73724,21.3502496 C134.038551,21.3502496 131.04017,24.3486301 131.04017,28.0473199 C131.04017,31.7460097 134.038551,43.017315 137.73724,43.017315 Z"
                    id="Oval-4"
                    fill="#FFB300"
                    opacity="0.2"
                    transform="translate(137.737240, 32.183782) scale(-1, 1) rotate(-45.000000) translate(-137.737240, -32.183782) "
                ></path>
                <path
                    d="M84.0897544,23.2633647 C88.0528645,23.2633647 91.2656,11.1862708 91.2656,7.22316076 C91.2656,3.26005066 88.0528645,0.0473151577 84.0897544,0.0473151577 C80.1266443,0.0473151577 76.9139088,3.26005066 76.9139088,7.22316076 C76.9139088,11.1862708 80.1266443,23.2633647 84.0897544,23.2633647 Z"
                    id="Oval-4"
                    fill="#60C2AA"
                    opacity="0.2"
                    transform="translate(84.089754, 11.655340) scale(-1, 1) translate(-84.089754, -11.655340) "
                ></path>
                <path
                    d="M37.134626,163.518569 C40.7520234,163.518569 43.6845034,152.494993 43.6845034,148.877595 C43.6845034,145.260198 40.7520234,142.327718 37.134626,142.327718 C33.5172285,142.327718 30.5847485,145.260198 30.5847485,148.877595 C30.5847485,152.494993 33.5172285,163.518569 37.134626,163.518569 Z"
                    id="Oval-4"
                    fill="#FFB300"
                    opacity="0.2"
                    transform="translate(37.134626, 152.923144) scale(1, -1) rotate(-45.000000) translate(-37.134626, -152.923144) "
                ></path>
                <path
                    d="M134.294964,161.309192 C136.966556,161.309192 139.13231,153.167842 139.13231,150.49625 C139.13231,147.824658 136.966556,145.658904 134.294964,145.658904 C131.623372,145.658904 129.457619,147.824658 129.457619,150.49625 C129.457619,153.167842 131.623372,161.309192 134.294964,161.309192 Z"
                    id="Oval-4"
                    fill="#FFB300"
                    opacity="0.2"
                    transform="translate(134.294964, 153.484048) scale(-1, -1) rotate(-45.000000) translate(-134.294964, -153.484048) "
                ></path>
                <path
                    d="M81.8334592,171.41146 C84.5504518,171.41146 86.7530096,163.131757 86.7530096,160.414764 C86.7530096,157.697772 84.5504518,155.495214 81.8334592,155.495214 C79.1164665,155.495214 76.9139088,157.697772 76.9139088,160.414764 C76.9139088,163.131757 79.1164665,171.41146 81.8334592,171.41146 Z"
                    id="Oval-4"
                    fill="#60C2AA"
                    opacity="0.2"
                    transform="translate(81.833459, 163.453337) scale(-1, -1) translate(-81.833459, -163.453337) "
                ></path>
                <path
                    d="M167.082919,108.037243 C172.843757,108.037243 177.513838,90.4817946 177.513838,84.7209571 C177.513838,78.9601196 172.843757,74.2900381 167.082919,74.2900381 C161.322082,74.2900381 156.652,78.9601196 156.652,84.7209571 C156.652,90.4817946 161.322082,108.037243 167.082919,108.037243 Z"
                    id="Oval-4"
                    fill="#60C2AA"
                    opacity="0.2"
                    transform="translate(167.082919, 91.163641) scale(-1, 1) rotate(-90.000000) translate(-167.082919, -91.163641) "
                ></path>
                <path
                    d="M9.86070183,97.4521409 C13.0787119,97.4521409 15.6874244,87.6456484 15.6874244,84.4276384 C15.6874244,81.2096283 13.0787119,78.6009157 9.86070183,78.6009157 C6.64269178,78.6009157 4.0339792,81.2096283 4.0339792,84.4276384 C4.0339792,87.6456484 6.64269178,97.4521409 9.86070183,97.4521409 Z"
                    id="Oval-4"
                    fill="#60C2AA"
                    opacity="0.2"
                    transform="translate(9.860702, 88.026528) scale(-1, 1) rotate(-270.000000) translate(-9.860702, -88.026528) "
                ></path>
            </g>
        </g>
    </g>
</svg>
